import { COLORS } from 'helpers/globals'
import { container, row, column30 } from 'helpers/styles/grid'

const button = {
  display: 'inline-block',
  width: '50%',
  border: `1px solid ${COLORS.primary}`,
  color: COLORS.primary,
  textAlign: 'center',
  cursor: 'pointer',
  verticalAlign: 'top',
  fontSize: 20,
  lineHeight: '22px',
  height: '100%',
  '&:first-of-type': { borderRight: 0 }
}

const selectScenesToggle = {
  ...column30,
  paddingLeft: '0 !important',
  textAlign: 'center',
  color: COLORS.primary,
  cursor: 'pointer'
}

const activeButton = {
  ...button,
  background: COLORS.primary,
  color: 'white'
}

export default {
  container: {
    ...container,
    fontSize: '1.4rem',
    marginBottom: '.5rem!important'
  },
  topRow: {
    ...row,
    height: 24
  },
  fovAdjuster: {
    ...column30,
    paddingRight: '0 !important',
    textAlign: 'center'
  },
  buttonBar: {
    ...column30,
    padding: '0 !important'
  },
  selectScenesToggle,
  selectScenesToggleActive: {
    ...selectScenesToggle,
    fontWeight: 400
  },
  fisheyeButton: {
    ...button,
    fontSize: '1.4rem'
  },
  activeFisheyeButton: {
    ...activeButton,
    fontSize: '1.4rem'
  },
  ConventionalButton: button,
  activeConventionalButton: activeButton,
  CorridorButton: {
    ...button,
    '& svg': { transform: 'rotate(0.75turn)' }
  },
  activeCorridorButton: {
    ...activeButton,
    '& svg': { transform: 'rotate(0.75turn)' }
  },
  caret: {
    marginLeft: '.5rem',
    color: COLORS.primary
  }
}



// WEBPACK FOOTER //
// ./src/components/FovPreview/FovModeButtonBar/style.js